import { render, staticRenderFns } from "./ModalityEdit.vue?vue&type=template&id=747e791b&"
import script from "./ModalityEdit.js?vue&type=script&lang=js&"
export * from "./ModalityEdit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports